var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('v-main',[_c('j-center-col',{style:({
        'background-color':
          typeof _vm.theme.primary === 'string' ||
          typeof _vm.theme.primary === 'number'
            ? _vm.theme.primary
            : _vm.theme.primary?.base || _vm.theme.primary,
      }),attrs:{"cols":"12","sm":"8","md":"4"}},[_c('router-view',{staticClass:"elevation-20"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }